import { gql } from '@apollo/client'

export default gql(`
query getBatchBucketGroupItems($input: [ID]){
    getBatchBucketGroupItems(
        input: $input
    ){
        id
        bucket{
            key
        }
    }
}`)
